import { createSelector } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.fileContainers[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectFileContainers = (state) => state.fileContainers.fileContainers;
export const selectInsuredRiskFileContainers = (state) => state.fileContainers.insuredRiskFileContainers;

const createFileContainersByTypeSelector = (type) =>
  createSelector([selectFileContainers], (fileContainers) =>
    fileContainers.filter((fileContainer) => fileContainer.type === type)
  );

export const selectClaimFileContainers = createFileContainersByTypeSelector('claim');
export const selectPolicyFileContainers = createFileContainersByTypeSelector('policy');
export const selectOrganizationFileContainers = createFileContainersByTypeSelector('organization');

export const selectFileContainersLoading = isLoadingSelector('getFileContainersStatus');
export const selectInsuredRiskFileContainersLoading = isLoadingSelector('getInsuredRiskFileContainersStatus');
